import { render, staticRenderFns } from "./NewsRow.vue?vue&type=template&id=406a9b00&"
import script from "./NewsRow.vue?vue&type=script&lang=js&"
export * from "./NewsRow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports